export interface KriteriaAuditFasilitasApd {
  no: number;
  kriteria: string;
  dasar_regulasi: string;
}

// 6 item blanko "AUDIT FASILITAS APD" Komite PPI RSPS (RSPS/AUDIT-APD-FAS/001).
export const KRITERIA_AUDIT_FASILITAS_APD: KriteriaAuditFasilitasApd[] = [
  {
    no: 1,
    kriteria: "Ada kebijakan alat pelindung diri",
    dasar_regulasi: "Permenkes 27/2017 (PPI); SNARS PPI 7"
  },
  {
    no: 2,
    kriteria:
      "Tersedia masker di ruang perawatan, intensif, dan tindakan sesuai dengan kebutuhan",
    dasar_regulasi: "Permenkes 27/2017 Lamp. (APD); SNARS PPI 7"
  },
  {
    no: 3,
    kriteria:
      "Tersedia sarung tangan non steril dan steril di ruang perawatan, intensif, dan ruang tindakan sesuai dengan kebutuhan",
    dasar_regulasi: "Permenkes 27/2017 Lamp. (APD); SNARS PPI 7"
  },
  {
    no: 4,
    kriteria:
      "Tersedia topi di ruang perawatan, intensif, dan ruang tindakan sesuai dengan kebutuhan",
    dasar_regulasi: "Permenkes 27/2017 Lamp. (APD); SNARS PPI 7"
  },
  {
    no: 5,
    kriteria: "Tersedia gaun di ruang tindakan sesuai dengan kebutuhan",
    dasar_regulasi: "Permenkes 27/2017 Lamp. (APD); SNARS PPI 7"
  },
  {
    no: 6,
    kriteria: "Tersedia sandal yang tertutup bagian depan di ruang tindakan",
    dasar_regulasi: "Permenkes 27/2017 Lamp. (APD); Permenkes 7/2019"
  }
];

export const METODE_AUDIT_OPTIONS = [
  { text: "Observasi Langsung", value: "observasi_langsung" },
  { text: "Wawancara", value: "wawancara" },
  { text: "Telusur Dokumen", value: "telusur_dokumen" }
];

export const PENILAIAN_OPTIONS = [
  { text: "Ya", value: "ya", color: "success", icon: "mdi-check-bold" },
  { text: "Tidak", value: "tidak", color: "error", icon: "mdi-close-thick" },
  { text: "N/A", value: "na", color: "grey", icon: "mdi-minus" }
];
